module.exports = __webpack_public_path__ + "img/logo.967e865d.png";